import React from "react";
import styles from "./FullProfile.module.css";

export default function PublicationSummary({ data }) {
  return (
    <>
      <h4>1 . Research Papers (Scops / ABDC / Wos / UGC / Peer-Reviewed)</h4>

      <div className={styles.noGrid}>
        {data?.researchPapers.length
          ? data?.researchPapers.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong>Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong>DOI : </strong>
                  <a href={item.DOI} target="_blank" rel="noopener noreferrer">
                    {item.DOI}
                  </a>
                </div>
                <div className={styles.publishRow}>
                  <strong>Auhtor : </strong> {item.authors}
                </div>
                <div className={styles.publishRow}>
                  <strong> Journal : </strong> {item.journalName}
                </div>
                <div className={styles.publishRow}>
                  <strong>Category : </strong> {item.indexingCategory}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
      <h4>2. Book Publications </h4>
      <div className={styles.noGrid}>
        {data?.bookPublications.length
          ? data?.bookPublications.map((item) => (
              <div key={item.bookTitle} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.bookTitle}</div>
                <div className={styles.publishRow}>
                  <strong> Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong> Publisher : </strong> {item.publisher}
                </div>
                <div className={styles.publishRow}>
                  <strong> ISBN : </strong> {item.ISBN}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
      <h4>3. Book Chapters</h4>
      <div className={styles.noGrid}>
        {data?.bookChapters.length
          ? data?.bookChapters.map((item) => (
              <div key={item.bookTitle} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.bookTitle}</div>
                <div className={styles.publishRow}>
                  <strong> Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong> DOI : </strong>
                  <a href={item.DOI} target="_blank" rel="noopener noreferrer">
                    {item.DOI}
                  </a>
                </div>
                <div className={styles.publishRow}>
                  <strong> Publisher : </strong> {item.publisher}
                </div>

                <div className={styles.publishRow}>
                  <strong>Chapter Title : </strong>
                  {item.chapterTitle}
                </div>
              </div>
            ))
          : "No Records"}
      </div>

      <h4>4. Conference Papers / Proceedings</h4>
      <div className={styles.noGrid}>
        {data?.conferencePapers.length
          ? data?.conferencePapers.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong> Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong>Organizer : </strong> {item.organizer}
                </div>
                <div className={styles.publishRow}>
                  <strong>Conference : </strong> {item.conferenceName}
                </div>
                <div className={styles.publishRow}>
                  <strong> Indexed : </strong> {item.indexed}
                </div>
              </div>
            ))
          : "No Records"}
      </div>

      <h4>  B. <span className={styles.blue}>Workshops / Seminars </span>
          <span className={styles.orange}>
            / Confrences / <br /> FDPs Attended
          </span></h4>
      <div className={styles.noGrid}>
        {data?.workshopSeminars.length
          ? data?.workshopSeminars.map((item) => (
              <div key={item.title} className={styles.bookContainer}>
                <div className={styles.bookTitle}> {item.title}</div>
                <div className={styles.publishRow}>
                  <strong> Year : </strong> {item.year}
                </div>
                <div className={styles.publishRow}>
                  <strong>Organizer : </strong> {item.organizer}
                </div>
                <div className={styles.publishRow}>
                  <strong>Category : </strong> {item.category}
                </div>
              </div>
            ))
          : "No Records"}
      </div>
    </>
  );
}
